import { render, staticRenderFns } from "./details-news.vue?vue&type=template&id=7870aca2&scoped=true&"
import script from "./details-news.vue?vue&type=script&lang=js&"
export * from "./details-news.vue?vue&type=script&lang=js&"
import style0 from "./details-news.vue?vue&type=style&index=0&id=7870aca2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7870aca2",
  null
  
)

export default component.exports